import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-05f2b937"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "wapper"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "loading"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "loading__image"
})], -1));
const _hoisted_3 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("span", null, _toDisplayString(_ctx.innerText), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.innerText), 1));
}